export function registerServiceWorker(
    browserWindow = typeof window === 'undefined' ? null : window,
    browserNavigator = typeof navigator === 'undefined' ? null : navigator
) {
    if (
        process.env.NODE_ENV !== 'production'
        || !browserWindow
        || !browserNavigator?.serviceWorker
    ) return Promise.resolve(null)

    const baseUrl = String(process.env.BASE_URL || '/')
    const serviceWorkerUrl = `${baseUrl.replace(/\/?$/, '/')}service-worker.js`
    return browserNavigator.serviceWorker.register(serviceWorkerUrl, { scope: baseUrl })
        .catch(() => null)
}
